import PageContent from "~/components/design-system/pages/internal/PageContent"
import {
  useRegisterInspector,
  useRegisterViewConfiguration,
} from "~/components/design-system/pages/internal/InspectorContext"
import { type OverviewPageProps } from "~/components/design-system/pages/types"

/**
 * Archetype page — at-a-glance dashboard (cards / summary tiles).
 * Defaults: full-width p-4, inspector open by default.
 * Canonical intent: {@link ../intents.ts OVERVIEW_PAGE_INTENT}.
 * Approved surface: design-system/APPROVED.md · Patterns: design-system/pages/README.md.
 */
const OverviewPage = ({
  children,
  inspector,
  inspectorDefaultOpen = true,
  inspectorWidth = "md",
  inspectorClassName,
  contentClassName,
  viewConfiguration,
  fillContent = false,
}: OverviewPageProps) => {
  useRegisterInspector(inspector, inspectorDefaultOpen, inspectorWidth, inspectorClassName)
  useRegisterViewConfiguration(viewConfiguration)
  return (
    <PageContent archetype="overview" className={contentClassName} fill={fillContent}>
      {children}
    </PageContent>
  )
}

export default OverviewPage
